<template>
    <transition name="fade">
        <div v-if="show" class="loading-overlay">
            <div class="loading-container">
                <div class="loading-messages">
                    <div
                        v-for="(message, index) in messages"
                        :key="index"
                        class="message-item"
                    >
                        <div class="message-text">{{ message.text }}</div>
                        <div class="message-time">
                            {{ message.status }}
                        </div>
                    </div>
                </div>
                <div class="loader"></div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "LoadingOverlay",
    props: {
        // Props for "Pengambilan link foto..."
        fotoStartTime: {
            type: String,
            default: ""
        },
        fotoEndTime: {
            type: String,
            default: ""
        },
        // Props for "Upload file..."
        uploadStartTime: {
            type: String,
            default: ""
        },
        uploadEndTime: {
            type: String,
            default: ""
        },
        // Props for "Penyimpanan file..."
        penyimpananStartTime: {
            type: String,
            default: ""
        },
        penyimpananEndTime: {
            type: String,
            default: ""
        },
        // Prop to control the overlay visibility
        show: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        messages() {
            return [
                {
                    text: "Pengambilan link file...",
                    status: this.getStatus(this.fotoStartTime, this.fotoEndTime)
                },
                {
                    text: "Upload file...",
                    status: this.getStatus(this.uploadStartTime, this.uploadEndTime)
                },
                {
                    text: "Penyimpanan file...",
                    status: this.getStatus(this.penyimpananStartTime, this.penyimpananEndTime)
                }
            ];
        }
    },
    methods: {
        getStatus(startTime, endTime) {
            if (startTime && endTime) {
                // Both start and end times are present
                return `Mulai ${startTime}, Selesai ${endTime}`;
            } else if (startTime && !endTime) {
                // Only start time is present, process is running
                return `Mulai ${startTime}, sedang berjalan...`;
            } else {
                // Both start and end times are null, waiting for previous process
                return "Menunggu proses sebelumnya";
            }
        }
    }
};
</script>

<style>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.loading-container {
    background: white;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
}
.loading-messages {
    margin-bottom: 24px;
}
.message-item {
    margin-bottom: 16px;
}
.message-item:last-child {
    margin-bottom: 0;
}
.message-text {
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 4px;
}
.message-time {
    font-size: 12px;
    color: #666;
}
/* Loading dots animation */
.loader {
    width: 15px;
    aspect-ratio: 1;
    border-radius: 50%;
    animation: l5 1s infinite linear alternate;
    margin: 24px auto 0;
}
@keyframes l5 {
    0%  {box-shadow: 20px 0 #000, -20px 0 #0002;background: #000 }
    33% {box-shadow: 20px 0 #000, -20px 0 #0002;background: #0002}
    66% {box-shadow: 20px 0 #0002,-20px 0 #000; background: #0002}
    100%{box-shadow: 20px 0 #0002,-20px 0 #000; background: #000 }
}
/* Fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
